<div class="content-container">
  <div class="lock-container">
    <img class="lock-image" src="images/lock.png" alt="Forbidden">
  </div>

  <div class="forbidden-info-container">
    <h1>403</h1>
    <h2>{{ 'FORBIDDEN.FORBIDDEN' | translate }}</h2>
    <p>{{ 'FORBIDDEN.YOU_DONT_HAVE_PERMISSION_TO' | translate }}</p>

    <a routerLink="/" class="back-home">{{ 'FORBIDDEN.GO_BACK_HOME' | translate }}</a>
    <span class="log-out text-link-primary" (click)="logOut()">{{ 'FORBIDDEN.LOG_OUT' | translate }}</span>
  </div>
</div>
